import {Form, type FormProps} from '../../../app/components/Form';
export interface NoteFormFieldValues {
  text: string;
}
export interface NoteFormProps extends Omit<FormProps<NoteFormFieldValues>, 'fields'> {}
export const NoteForm = (props: NoteFormProps) => {
  return (
    <Form
      submitButton={{
        children: 'Save',
        variant: 'warning',
      }}
      {...props}
      fields={[
        {
          label: 'Note',
          name: 'text',
          rules: {
            maxLength: 200,
          },
          type: 'textarea',
          typeOptions: {
            autoFocus: true,
            maxLength: 200,
            rows: 6,
          },
        },
      ]}
    />
  );
};
